<template>
  <div class="row customers">
    <div class="col-lg-3 col-md-4 col-xs-4">
      <div class="row">
        <div class="fixed" :style="{height: windowHeight + 'px'}">
          <div class="table-top" ref="tableTop">
            <el-row>
              <el-col>
                <el-input v-model="filters[0].value" :placeholder="$t('general.search')" class="icon-search"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="table-container" :style="{height: windowHeight - tableTopHeight + 'px'}">
            <data-tables class=""
                      v-loading="loading"
                      :data="tableData"
                      :current-page="1"
                      :page-size="paginationDef.pageSize"
                      @row-click="goToRecord"
                      :filters="filters"
                      :table-props="{'row-class-name': rowClass, 'border': false, 'stripe': false,}"
                      style="width: 100%; background: #fff"
                      >
              <el-table-column
                label=""
                :min-width="80">
                <template slot-scope="props">
                  <div><b># {{props.row.id}}</b></div>
                  <template v-if="props.row.firstname != null || props.row.lastname != null">
                    {{ props.row.firstname}} {{ props.row.lastname}}
                  </template>
                  <template v-else>
                    <small>{{ props.row.email}}</small>
                  </template>
                  <div class="xxs-font">{{ $t('orders.counterPerCustomer') }} {{ props.row.counter_orders_per_customer }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label=""
                :min-width="60">
                <template slot-scope="props">
                  <b>{{ props.row.sales > 0 ? formatMoneyAmount(props.row.sales, props.row.currency) : '' }}</b>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-md-8 col-xs-8 detailsScroll" ref="detailsScroll" :style="{height: windowHeight + 'px'}">
      <customer-view v-if="showForm()" ref="customerForm"></customer-view>
      <div class="no-element" v-if="!showForm()">
        <i class="user"></i>
        <div>{{ $t('customers.noCustomer') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Select, Option, Pagination, Row} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import CustomerView from './CustomerView.vue'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  Vue.use(Row)
  export default{
    components: {
      PPagination,
      PSwitch,
      CustomerView
    },
    computed: {
    },
    created: function () {
      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/customer', 'GET', data, function (response) {
        if (response.status === true) {
          for (var cust of response.data) {
            cust['fullname'] = cust['firstname'] + ' ' + cust['lastname']
          }
          self.tableData = response.data
          self.paginationDef.pageSize = self.tableData.length + 1
        }
        self.$nextTick(function () {
          self.loading = false
        })
      })
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          pageSize: 99999,
          currentPage: 1,
          pageSizes: [99999],
          show: false
        },
        searchQuery: '',
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [],
        tableData: [],
        windowHeight: 0,
        tableTopHeight: 70,
        filters: [
          {
            value: '',
            prop: ['firstname', 'lastname', 'sales', 'id', 'email', 'phone', 'fullname']
          }
        ]
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight
        this.tableTopHeight = this.$refs.tableTop.clientHeight

        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
          this.tableTopHeight = this.$refs.tableTop.clientHeight
        })
      })
    },
    methods: {
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/customers/view/')
        this.$refs.customerForm.getData()
      },
      rowClass (row, index) {
        if (this.$route.params.id && (parseInt(row.row.id) === parseInt(this.$route.params.id))) {
          return 'current'
        } else {
          return ''
        }
      },
      showForm () {
        if (this.$route.path.indexOf('view') !== -1) {
          return true
        } else {
          return false
        }
      },
      handleActive (index, row, e) {
        let actionText = row.active ? 'activate' : 'deactivate'
        swal({
          text: `Are you sure you want to ${actionText} ${row.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result) {
            this.apiRequest('/hello', 'GET', [], function (response) {
              console.log(response)
              if (response.status) {
                swal(
                  'Success!',
                  '',
                  'success'
                )
              } else {
                swal(
                  '',
                  'Something went wrong, please try again later...',
                  'error'
                )
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          swal(
            '',
            'Something went wrong, please try again later...',
            'error'
          )
          row.active = !row.active
        })
      },
      handleDelete (index, row) {
        var btnCounter = 3
        swal({
          text: `Are you sure you want to delete '${row.name}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes (' + btnCounter + ')'
        })
        .then((result) => {
          var self = this
          if (result) {
            this.apiRequest('/hello', 'GET', [], function (response) {
              console.warn(response)
              if (response.status === true) {
                swal(
                  '',
                  'Product deleted successfully',
                  'success'
                )
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  'Something went wrong, please try again later...',
                  'error'
                )
              }
            })
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = 'Yes'
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Customers/Customers.vue